import React from 'react'
import { Link } from 'react-router-dom';

const PageNotFound = () => {
    return (
        <div id='pagenotfound' style={{fontSize: 40, fontWeight: 900}}>
            <div className='center'>
                <div>
                    <div>
                        Sorry!
                    </div>
                    <div style={{fontSize: 30, fontWeight: 500}}>
                        This page does not exist on my portfolio yet.
                    </div>
                    <Link to="/" style={{fontSize: 20, fontWeight: 500, margin: 25}}>
                        View Portfolio
                    </Link>
                </div>
                <img id="me_photo" src={process.env.PUBLIC_URL + "/assets/introduction/asci.png"} />
            </div>
        </div>
    )
}

export default PageNotFound;